enum POST_COLLAB_PUBLISH_MODE {
    full = 'full',
    preview = 'preview',
}

export { POST_COLLAB_PUBLISH_MODE };
